import { FormattedMessage } from 'react-intl';
import { BugOutlined } from '@ant-design/icons';

// type
import { NavItemType } from '../types/menu';
import { DeepReadonly } from '../types/DeepReadonly';
import { useMemo } from 'react';

const useDebugMenuItems = (): DeepReadonly<NavItemType> =>
	useMemo(
		() => ({
			id: 'debug',
			type: 'group',
			children: [
				{
					id: 'debug',
					title: <FormattedMessage id={'menu.debug'} />,
					type: 'item',
					url: '/debug',
					icon: BugOutlined,
					isActive: (location) => location.pathname.startsWith('/debug'),
				},
			],
		}),
		[],
	);

export { useDebugMenuItems };
